<template>
	<div class="reserve-background-width" style="max-width: 100% !important;  height: 100vh; width:1080px; overflow:auto; min-width:1080px;">
		<div v-if="step === '1'">
			<v-img v-if="eventsData.eventImg" :src="$store.state.frontServer_upload + eventsData.eventImg.url" @error="imgError()">
				<v-layout class="clickBtn" wrap justify-center>
					<div class="start-button-group">
						<button @click="startEventWithPurpose()" class="start-button">
							응모하기
						</button>
					</div>
				</v-layout>
			</v-img>
			<v-img v-else-if="eventsData.eventImg === null" :src="defaultImg" class="imageButton"> </v-img>
		</div>
		<div v-show="step === '2'">
			<main class="content_step2">
				<section class="info-section">
					<section class="info-header"><span class="mr-2">|</span> 기본 정보 입력 <span class="ml-2">|</span></section>

					<div class="info-form">
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">이 름</label>
								<v-flex xs12>
									<txtField
										class="placeholder-color-white font-size-30"
										:txtField="nametxtField"
										v-model="nametxtField.value"
										@input="disableNext()"
									></txtField>
								</v-flex>
							</v-layout>
						</div>

						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">전화번호</label>
								<v-layout wrap>
									<v-flex xs2>
										<select-box :sel="numSel" @change="change"></select-box>
									</v-flex>
									<v-flex xs10 class="pl-1">
										<txtField class="placeholder-color-white font-size-30" :txtField="numtxtField" v-model="numtxtField.value"></txtField>
									</v-flex>
								</v-layout>
							</v-layout>
						</div>
						<!-- <div class="form-group">
							<v-layout align-center>
								<label class="form-label">방문경로</label>
								<v-layout wrap>
									<v-flex xs12 class="pl-1">
										<div
											style="display: flex; align-items: center; justify-content: center; margin-top: 20px; margin-bottom: 20px; color:white;"
										>
											<div v-for="(label, i) in reserveCheckList" :key="i" style="display: flex; align-items: center;">
												<input
													type="checkbox"
													:id="'marketing-agree' + i"
													:checked="reserveCheckData.indexOf(label) > -1"
													@click="setCheck(label)"
													style="width: 32px; height: 32px; margin-right: 4px;"
												/>
												<label :for="'marketing-agree' + i" style="font-size: 24px; margin-right: 12px;">{{ label }}</label>
											</div>
										</div>
									</v-flex>
								</v-layout>
							</v-layout>
						</div> -->
						<v-flex xs12>
							<v-layout wrap class="mt-4 keypad_background">
								<v-flex xs9>
									<keyboard_kr @onChange="onChange_kr" @onKeyPress="onKeyPress_kr" :input="nametxtField.value" />
								</v-flex>
								<v-flex xs3 class="pl-3">
									<keyboard_number @onChange="onChange_number" :input="numtxtField.value" />
								</v-flex>
							</v-layout>
						</v-flex>
					</div>
				</section>
				<section class="info-desc">
					<div class="next-button-container">
						<button class="action-button-outlined mr-4" @click="step = '1'">이전으로</button>
						<div class="nextButton_css" @click="submitForm">
							<span class="text">다음으로</span>
							<span class="arrow">&#8250;</span>
						</div>
					</div>

					<!-- 개인정보 수집 및 이용에 대한 안내 -->
					<div class="consent-section">
						<div class="consent-header"><span class="consent-header-icon">■</span> 개인정보수집 및 이용에 대한 안내</div>
						<div class="consent-description">
							개인정보보호법 등 관련 법규에 의거하여 상기 본인은 아래와 같이 개인정보 수집 및 활용에 동의합니다.<br />
							고객의 개인정보는 '해링턴 플레이스 오룡역'의 고객 서비스 제공 이외의 다른 목적으로 사용되지 않음을 알려드립니다.<br />
							'해링턴 플레이스 오룡역'은 방문고객 경품 이벤트와 관련하여 아래와 같이 개인정보를 수집하고 있습니다.
						</div>
						<table class="consent-table">
							<tr class="consent-table-header-row">
								<th>개인정보를 수집·이용하는 자</th>
								<td>{{ companyInfo.name }}</td>
							</tr>
							<tr>
								<th>수집 및 이용 항목</th>
								<td>{{ companyInfo.purpose }}</td>
							</tr>
							<tr>
								<th>수집 및 이용 목적</th>
								<td>{{ companyInfo.usage }}</td>
							</tr>
							<tr>
								<th>개인정보의 보유 및 이용기간</th>
								<td>{{ companyInfo.retention }}</td>
							</tr>
							<tr>
								<th>개인정보의 동의를 거부할 권리</th>
								<td>{{ companyInfo.rights }}</td>
							</tr>
						</table>

						<div class="consent-agree-row">
							<span class="consent-agree-label">개인정보 수집 및 이용동의</span>
							<span class="consent-agree-options">
								<span class="consent-option" :class="{ active: privacyAgree }" @click="setPrivacyAgree(true)">
									<span class="consent-radio">{{ privacyAgree ? '●' : '○' }}</span> 동의
								</span>
								<span class="consent-option" :class="{ active: !privacyAgree }" @click="setPrivacyAgree(false)">
									<span class="consent-radio">{{ !privacyAgree ? '●' : '○' }}</span> 동의하지 않음
								</span>
							</span>
						</div>
					</div>

					<!-- 마케팅 정보 활용 동의 -->
					<div class="consent-section mt-4">
						<table class="consent-table">
							<tr class="consent-table-header-row">
								<th>마케팅 정보 활용 수집·이용하는 자</th>
								<td>{{ marketing.name }}</td>
							</tr>
							<tr>
								<th>마케팅 정보 활용 이용 항목</th>
								<td>{{ marketing.purpose }}</td>
							</tr>
							<tr>
								<th>마케팅 정보 활용 이용 목적</th>
								<td>{{ marketing.usage }}</td>
							</tr>
							<tr>
								<th>마케팅 정보 활용 이용기간</th>
								<td>{{ marketing.retention }}</td>
							</tr>
							<tr>
								<th>마케팅 정보 활용 동의를 거부할 권리</th>
								<td>{{ marketing.rights }}</td>
							</tr>
						</table>

						<div class="consent-agree-row">
							<span class="consent-agree-label">마케팅 정보 활용 이용동의</span>
							<span class="consent-agree-options">
								<span class="consent-option" :class="{ active: agree }" @click="setAgree(true)">
									<span class="consent-radio">{{ agree ? '●' : '○' }}</span> 동의
								</span>
								<span class="consent-option" :class="{ active: !agree }" @click="setAgree(false)">
									<span class="consent-radio">{{ !agree ? '●' : '○' }}</span> 동의하지 않음
								</span>
							</span>
						</div>
					</div>
				</section>
			</main>
		</div>
		<div v-show="step === '3'">
			<main class="content_step3">
				<section class="info-header" style="margin-top:100px !important;">
					<span class="mr-2">|</span> 인증번호 입력 <span class="ml-2">|</span>
				</section>
				<div class="auth-header">
					<p class="bold">문자메시지로 전송된 본인 인증번호를 입력해주세요.</p>
					<p>(문자메시지 발송에는 약 10초~20초 소요됩니다.)</p>
				</div>

				<div class="auth-form">
					<div class="auth-input-container">
						<input type="text" id="auth-input" v-model="authCode" readonly />
					</div>

					<div class="keypad">
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('1')">1</button>
							<button class="key number-key" @click="addNumber('2')">2</button>
							<button class="key number-key" @click="addNumber('3')">3</button>
						</div>
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('4')">4</button>
							<button class="key number-key" @click="addNumber('5')">5</button>
							<button class="key number-key" @click="addNumber('6')">6</button>
						</div>
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('7')">7</button>
							<button class="key number-key" @click="addNumber('8')">8</button>
							<button class="key number-key" @click="addNumber('9')">9</button>
						</div>
						<div class="keypad-row">
							<button class="key clear-key" @click="clearAll()">전체<br />지움</button>
							<button class="key number-key" @click="addNumber('0')">0</button>
							<button class="key backspace-key" @click="backspace()">←</button>
						</div>
					</div>
				</div>
				<div class="action-button-container">
					<button class="action-button-outlined mr-4" @click="step = '2'">이전으로</button>
					<div class="nextButton_css" @click="submitAuthCode()">
						<span class="text">입력완료</span>
						<span class="arrow">&#8250;</span>
					</div>
				</div>
			</main>
			<v-dialog v-model="roulletDialog" overlay-opacity="0.9" eager persistent content-class="roullet_dialog">
				<div class="roullet_div">
					<img class="roullet_arrow" src="@/assets/images/roullet_arrow.png" />
					<img class="roullet_board" ref="roullet_board" :src="roulletImg" />
				</div>
			</v-dialog>
		</div>
		<main class="content_step4" v-show="step === '4'">
			<v-img src="@/assets/images/3_orong.png" class="imageButton">
				<v-layout class="clickBtn" wrap justify-center style="bottom: 680px !important;">
					<button @click="startEvent()" class="nextButton_css" style="width: 500px!important; background-color: white;">
						<span class="text" style="color: #222A65;">응모권 출력</span>
						<span class="arrow" style="color: #222A65;">&#8250;</span>
					</button>
				</v-layout>
			</v-img>
		</main>
		<v-dialog v-model="lucky" width="90%" persistent content-class="check_dialog">
			<v-img :src="luckyImage" eager height="85vh" />
			<div class="check_info my-2" style="font-size: 28px; font-weight: bold;">
				※경품 교환권 출력을 누르시면 출력기에서 경품 교환권이 출력 됩니다.
			</div>
			<v-btn :color="btnColor" x-large dark @click="print()" block style="font-size: 36px;" height="64">
				경품 교환권 출력
			</v-btn>
		</v-dialog>
		<!-- 드래그 버전 설문 모달 -->
		<reservevisitModalDrag :setdialog="reserveDialog" :title="placeTitle" :eventsData="eventsData"></reservevisitModalDrag>
		<div id="print-background-cobe">
			<div
				style="display: flex; justify-content: center; align-items: center; background-color: #f5f5f5; margin: 0; padding: 0; font-family: 'Noto Sans KR', Arial, sans-serif;"
			>
				<div
					style="width: 100%; height: auto; background-color: white; overflow: hidden; text-align: center; padding: 12px 5px; display: flex; flex-direction: column;"
				>
					<div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">해링턴 플레이스 오룡역</div>
					</div>

					<div style="margin-bottom: 10px;">
						<div style="font-size: 24px; font-weight: bold; color: #000; line-height: 24px;">키오스크 경품 이벤트</div>
					</div>
					<div style="border: 1px solid black; border-radius: 10px; margin: 0 4px; padding: 4px;">
						<div style="text-align: center; font-weight: bold; font-size: 24px; line-height: 24px;">{{ nametxtField.value }} 고객님</div>
						<div style="text-align: center; font-weight: bold; font-size: 24px; line-height: 24px;">
							{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
						</div>
						<div style="text-align: center; font-weight: bold; font-size: 24px; line-height: 24px;">
							{{ winnterProduct }}
						</div>
						<div style="text-align: center; font-size: 24px; margin-bottom: 4px; margin-top: 4px; font-weight: bold; line-height: 24px;">
							({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
						</div>
					</div>
					<div style="margin-top: 10px; margin-bottom: 10px;">
						<div style="font-size: 14px; font-weight: bold; margin-bottom: 1px;">경품 당첨을 축하드립니다.</div>
						<div style="font-size: 11px; font-weight: bold; color: #777;">※ 경품수령은 수령처에서 수령하여 주시기 바랍니다.</div>
					</div>
				</div>
			</div>
		</div>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal5, keyboard_kr, keyboard_number, reservevisitModalDrag, selectBox, txtField } from '@/components/index.js'
import Hangul from 'hangul-js'
export default {
	components: {
		txtField,
		selectBox,
		keyboard_kr,
		keyboard_number,
		reservevisitModalDrag,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			roulletImg: null,
			roulletDialog: false,
			selectedPurpose: '',
			reserveCheckData: [],
			reserveCheckList: ['신문기사', '온라인광고', '홈페이지', 'TV광고', '차량광고'],
			privacyAgree: true,
			agree: true,
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			numtxtField: {
				height: 50,
				color: 'white',
				label: '전화번호를 입력하세요',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: true,
			},
			nametxtField: {
				height: 50,
				value: '',
				solo: true,
				readonly: true,
				label: '이름을 입력하세요',
				dark: false,
				color: 'white',
			},
			numSel: {
				value: '010',
				solo: true,
				class: 'selectNum',
				items: ['010', '011', '016', '017'],
				dark: false,
				color: 'white',
				height: 50,
			},
			authCode: '',
			step: '1',
			scheduleData: [
				{ type: '특별공급', date: '4.28', day: '월' },
				{ type: '1순위', date: '4.29', day: '화' },
				{ type: '2순위', date: '4.30', day: '수' },
			],
			houseInfo: [{ size: '84m²' }, { size: '101m²' }, { size: '108m²' }],
			totalUnits: 307,
			contactNumber: '1600.0255',

			footnotes: [
				'당첨 후 경품 수령시 성명, 연락처가 일치하여야만 경품 수령이 가능합니다.',
				'상기 경품 이미지는 실제와 다를 수 있습니다.',
				'해당 이벤트는 사은품 소진 수량 소진시 이벤트가 종료될 수 있습니다.',
				'경품 제세공과금(22%)은 소비자부담입니다.',
			],
			nameTxtArray: [],
			companyInfo: {
				name: '진흥기업㈜, ㈜CLK',
				purpose: '성명 및 연락처',
				usage: "'해링턴 플레이스 오룡역' 분양정보에 대한 안내(전화, 문자) 및 경품추첨 등에 관한 일체 행위",
				retention: '분양완료 후 30일 이내',
				rights:
					'귀하께서는 개인정보수집 및 이용을 거절하실 수 있으며, 거절하실 경우 경품 당첨 등의 서비스를 제공해 드릴 수 없습니다. (개인정보제공에 동의하지 않으실 경우 경품 응모를 하실 수 없습니다.)',
			},
			marketing: {
				name: '진흥기업㈜, ㈜CLK',
				purpose: '성명 및 연락처',
				usage:
					'마케팅 정보제공에 동의 시 새로운 정보를 제공받으실 수 있으며, 각종 이벤트에도 참여할 수 있습니다.\n본 정보는 고객님이 동의한 활용목적으로만 사용하고 있습니다.',
				retention: '마케팅 정보 활용 동의 시점부터 1년간 (이후 폐기합니다. 본 동의 철회 시 즉시 폐기됩니다.)',
				rights: '귀하께서는 개인정보수집 및 이용을 거절하실 수 있으며,\n거절하실 경우 분양정보 안내 등의 서비스를 제공해 드릴 수 없습니다.',
			},
			eventsData: {},
			code: '',
			winnterProduct: '',
			btnColor: '',
			lucky: false,
			luckyImage: '',
			check_dialog: false,
			keypadInput: false,
			keyboardData: '',
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn2',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: {
					value: '',
					outlined: true,
					placeholder: '성명을 입력하세요.',
					color: 'black',
				},
				numSel: {
					value: '010',
					outlined: true,
					class: 'selectNum',
					items: ['010', '011', '016', '017'],
					color: 'black',
				},
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '숫자만 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '',
			surveyLegnth: 0,
			agreeContent: '',
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData4: {}, // 내가받을 알림톡 알림톡 데이터
		}
	},

	async created() {
		// Check if route parameter is cobeplan and set appropriate code based on Korean date
		if (this.$route.params.code === 'cobe51') {
			const today = this.$moment() // Korean timezone
			const day = today.date()
			const month = today.month() + 1 // moment months are 0-indexed
			console.log(month, day, today.hours())

			if (month === 5 && day === 9) {
				this.code = 'cobe52' // Code for April 19
			} else if (month === 5 && day === 10) {
				this.code = 'cobe53' // Code for April 20
			} else {
				this.code = this.$route.params.code // Default to the route param
			}
		} else {
			this.code = this.$route.params.code
		}
		this.roulletImg = require('@/assets/images/roullet_ha.png')
		await this.events()
	},
	methods: {
		winnerRoulletIndex() {
			if (this.winnterProduct === '5등 직사각티슈') return 1
			// ok
			else if (this.winnterProduct === '4등 각티슈+송월타올 30수 모나코 130g') return 3
			// ok
			else if (this.winnterProduct === '3등 필립스 퓨어 프로텍트 프로 공기청정기 3200 시리즈') return 0
			// ok
			else if (this.winnterProduct === '2등 다이슨 DIGITALSLIM(Y24)') return 5
			// ok
			else if (this.winnterProduct === '1등 LG TV') return 2

			// ok
		},
		/****룰렛 돌리기
 자동으로 룰렛 돌리고 설정한 시간 이후 팝업 자동으로 닫히기
	 @author 전현균
 */
		spinRoullet() {
			this.roulletDialog = true

			let roullet_board = this.$refs.roullet_board

			roullet_board.style.transform = `rotate(15deg)`
			roullet_board.style.transition = `initial`

			const ready_second = 300 // 다이어로그 띄워지기 까지 대기 시간
			const spin_second = 500 // 룰렛 돌아가는 시간
			const close_second = 300 // 룰렛 완료 후 대기 시간
			const spin_number = 10 // 룰렛 회전 횟수

			const product_total = 6 // 상품 갯수
			// const index = 5
			// 룰렛 돌리고 원하는 위치에 룰렛 멈추기
			const ran = Math.floor(this.winnerRoulletIndex() * product_total)
			// const ran = Math.floor(index * product_total)

			const arc = 360 / product_total
			setTimeout(() => {
				const rotate = ran * arc - this.winnerRoulletIndex() * arc + 360 * spin_number - 60 + arc / 2
				// const rotate = ran * arc - index * arc + 360 * spin_number - 60 + arc / 2

				roullet_board.style.transform = `rotate(${rotate}deg)`
				roullet_board.style.transition = `${spin_second}ms cubic-bezier(0,0,0,.98)`

				var audio = new Audio('/roulette sound.mp3')
				audio.load()
				audio.volume = 1
				audio.play()
			}, ready_second)

			// 폭죽 효과
			setTimeout(() => {
				this.firework()
			}, spin_second + ready_second)

			// 룰렛 완료 후 룰렛 닫기
			setTimeout(() => {
				this.roulletDialog = false
				this.lucky = true
			}, spin_second + ready_second + close_second)
		},
		setCheck(label) {
			if (this.reserveCheckData.indexOf(label) > -1) this.reserveCheckData.splice(this.reserveCheckData.indexOf(label), 1)
			else this.reserveCheckData.push(label)
		},
		setAgree(val) {
			this.agree = val
		},
		setPrivacyAgree(val) {
			this.privacyAgree = val
		},
		async eventJoins() {
			this.$store
				.dispatch('eventJoins', {
					code_in: [this.code],
					phone: String(this.numSel.value + this.numtxtField.value),
				})
				.then(res => {
					if (res.data.eventJoins.length > 0) {
						this.alertModal.text = '이미 응모하신 번호입니다.'
						this.$store.state.loading = false
						this.step = '1'
						this.numtxtField.value = ''
						this.nametxtField.value = ''
						this.nameTxtArray = []
						return (this.alertModal.dialog = true)
					} else this.startEvent()
				})
		},
		async authCodecheck() {
			const data = {
				receiver: this.numSel.value + this.numtxtField.value,
				// sender: this.setdialog.nametxtField.value,
				authCode: String(this.authCode),
			}
			await this.$store.dispatch('sendSms', data).then(res => {
				if (res.data.sendSms.length > 0) {
					this.step = '4'
					// this.createEventJoin()
				} else {
					this.alertModal.dialog = true
					this.alertModal.text = '인증번호가 틀렸습니다.'
				}
			})
		},
		phoneCrypto(data) {
			return data.replace(/\d(?=\d{4})/g, '*')
		},
		print() {
			if (process.env.IS_ELECTRON) {
				// 일렉트론 환경에서 실행될 때
				const printContent = document.getElementById('print-background-cobe').innerHTML
				const { ipcRenderer } = window.require('electron')

				// 메인 프로세스로 프린트 요청 전송
				ipcRenderer.send('print-document', printContent)

				// 프린트 완료 후 실행할 작업
				setTimeout(() => {
					this.authCode = ''
					this.numtxtField.value = ''
					this.nametxtField.value = ''
					this.nameTxtArray = []
					this.reserveCheckData = []
					this.$store.state.loading = false
				}, 1000)

				return false
			} else {
				// 브라우저 프린트 다이얼로그를 숨기기 위한 iframe 생성 방식
				const printContent = document.getElementById('print-background-cobe').innerHTML
				const printFrame = document.createElement('iframe')

				// iframe 스타일 설정
				printFrame.style.position = 'fixed'
				printFrame.style.right = '0'
				printFrame.style.bottom = '0'
				printFrame.style.width = '0'
				printFrame.style.height = '0'
				printFrame.style.border = '0'

				document.body.appendChild(printFrame)

				// iframe 내용 설정
				const frameDoc = printFrame.contentWindow.document
				frameDoc.open()
				frameDoc.write(`
    <html>
      <head>
        <style>
          @page {
            size: 110mm 190mm; /* 영수증 크기에 맞게 조정 */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${printContent}</body>
    </html>
  `)
				frameDoc.close()

				// 프린트 실행
				printFrame.contentWindow.focus()

				// 약간의 지연 후 프린트 실행 (내용이 로드되기를 기다림)
				setTimeout(() => {
					printFrame.contentWindow.print()

					// 프린트 후 iframe 제거
					setTimeout(() => {
						document.body.removeChild(printFrame)
						this.authCode = ''
						this.numtxtField.value = ''
						this.nametxtField.value = ''
						this.nameTxtArray = []
						this.agree = true
						this.$store.state.loading = false
					}, 1000)
				}, 500)
				this.step = '1'
				this.lucky = false
				return false
			}
		},
		createSendSm() {
			var randomCode = Math.floor(Math.random() * 1000000) + 100000
			if (randomCode > 1000000) {
				randomCode = randomCode - 100000
			}
			var message = `[키오스크 이벤트 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`
			const data = {
				receiver: this.numSel.value + this.numtxtField.value,
				message: message,
				authCode: String(randomCode),
				sender: process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
			}
			this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					alert('SMS 전송시 오류가 발생하였습니다. 다시 시도해 주세요.')
					console.log({ err })
				})
		},
		startEventWithPurpose(purpose) {
			this.selectedPurpose = purpose
			this.startEvent()
		},
		createEventJoin() {
			this.$store.state.loading = true
			let data2 = {
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,
				code: this.code,
				marketing: this.agree,
				purpose: this.selectedPurpose,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store.dispatch('createEventJoin', data2).then(res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal.dialog = true
					this.$store.state.loading = false
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal.dialog = true
					this.$store.state.loading = false
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					if (
						res.data.createEventJoin.eventJoin.winnterProduct === '2등 다이슨 DIGITALSLIM(Y24)' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '3등 필립스 퓨어 프로텍트 프로 공기청정기 3200 시리즈' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '4등 각티슈+송월타올 30수 모나코 130g' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '5등 직사각티슈'
					) {
						this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)
						setTimeout(() => {
							this.spinRoullet()
						}, 500)
						this.check_dialog = false
					} else {
						setTimeout(() => {
							this.print()
						}, 1000)
					}
				}
			})
		},
		async eventJoinsConnection() {
			await this.$store.dispatch('eventJoinsConnection', { code: this.code }).then(res => {
				if (this.eventsData.maxcount < res.data.eventJoinsConnection.aggregate.count) {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			})
		},
		async events() {
			this.$store.state.loading = true
			const data = {
				code: this.code,
			}
			await this.$store
				.dispatch('events', data)
				.then(res => {
					if (res.data.events.length === 0) {
						this.$router.push({ name: 'notfound' })
					}
					this.eventsData = res.data.events[0]
					this.$store.state.loading = false
					this.eventJoinsConnection()
					if (this.eventsData.business) {
						this.nextbtn.color = this.eventsData.business.color
						this.btnColor = this.eventsData.business.color
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		change() {
			return {}
		},

		addNumber(number) {
			if (this.authCode.length < 6) this.authCode += String(number)
		},
		clearAll() {
			this.authCode = ''
		},
		backspace() {
			this.authCode = this.authCode.slice(0, -1)
		},
		submitAuthCode() {
			if (this.authCode.length > 0 && this.authCode.length < 7) {
				this.startEvent()
				// 여기에 실제 인증 로직 추가
			} else {
				this.alertModal.text = '인증번호 6자리를 입력해주세요.'
				this.alertModal.dialog = true
			}
		},
		async submitForm() {
			if (!this.privacyAgree) {
				this.alertModal.text = '개인정보 수집 및 이용에 동의해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.nametxtField.value) {
				this.alertModal.text = '이름을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.numtxtField.value) {
				this.alertModal.text = '전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.numtxtField.value.length < 8) {
				this.alertModal.text = '최소 7자리의 올바른 전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.numtxtField.value === '00000000') return this.createEventJoin()
			if (this.eventsData.duplicate === false) await this.eventJoins()
			else this.startEvent()
		},
		startEvent() {
			if (this.step === '1') {
				// 서버로부터 받은 이벤트 시작/종료 날짜를 한국 시간으로 변환
				const startDate = this.$moment(this.eventsData.start).utcOffset('+09:00')
				const endDate = this.$moment(this.eventsData.end).utcOffset('+09:00')
				const currentDate = this.$moment().utcOffset('+09:00')
				// 현재 시간이 이벤트 기간 내인지 확인
				const isEventActive = currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate)
				if (isEventActive) {
					this.eventJoinsConnection()
					this.step = '2'
				} else if (currentDate.isBefore(startDate)) {
					this.alertModal.text = '이벤트가 아직 시작되지 않았습니다.'
					return (this.alertModal.dialog = true)
				} else {
					this.alertModal.text = '이벤트가 종료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			} else if (this.step === '2') {
				// 인증제거
				// this.createEventJoin()
				this.createSendSm()
				this.step = '3'
			} else if (this.step === '3') this.authCodecheck()
			else if (this.step === '4') this.createEventJoin()
		},
		onChange_kr() {
			this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
		},
		onKeyPress_kr(button) {
			if (button === '{retry}') {
				this.nametxtField.value = ''
				this.nameTxtArray = []
			} else {
				if (button !== '{bksp}') {
					this.nameTxtArray.push(button)
				} else {
					if (this.nameTxtArray.length > 0) {
						this.nameTxtArray.splice([this.nameTxtArray.length - 1], 1)
						this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
					}
				}
			}
		},
		onChange_number(input) {
			if (input.length < 9) this.numtxtField.value = input
		},
		nameCrypto(name) {
			if (name.length === 1) {
				return name
			} else if (name.length === 2) {
				return name.slice(0, 1) + '*'
			} else {
				return name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1)
			}
		},
		print_test() {
			var initBody
			window.onbeforeprint = () => {
				initBody = document.body.innerHTML
				document.getElementById('back-setting').style.backgroundColor = 'black'
				document.body.innerHTML = document.getElementById('print').innerHTML
			}
			window.onafterprint = () => {
				document.getElementById('back-setting').style.backgroundColor = 'white'
				document.body.innerHTML = initBody
			}
			window.print()
			return false
		},
		cancel() {
			this.nameTxtArray = []
			this.keypadInput = false
			this.agree = true
			this.privacyAgree = true
			this.nametxtField.value = ''
			this.numSel.value = '010'
			this.numtxtField.value = ''
			this.reserveCheckData = []
			this.selectedPurpose = ''
		},
		terms(id) {
			const data = {
				stat: 1,
				id: id,
			}
			this.$store.dispatch('terms', data).then(res => {
				if (res.data.terms.length > 0) {
					this.agreeContent = res.data.terms[0].content
				}
			})
		},

		imgError() {
			this.eventsData.eventImg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.eventsData.population || this.eventsData.population === '설정 해제') {
						if (this.eventsData.accessPhones !== '' && this.Data.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},

		disableNext() {},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.eventsData.accessPhones
				.filter(x => x.name === this.startDialog.nametxtField.value)
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		imageUrl(data) {
			if (data === '2등 다이슨 DIGITALSLIM(Y24)') return require('@/assets/images/orng_2.jpg')
			else if (data === '3등 필립스 퓨어 프로텍트 프로 공기청정기 3200 시리즈') return require('@/assets/images/orng_3.jpg')
			else if (data === '4등 각티슈+송월타올 30수 모나코 130g') return require('@/assets/images/orng_4.jpg')
			else if (data === '5등 직사각티슈') return require('@/assets/images/orng_5.jpg')
			else if (data === '1등 LG TV') return require('@/assets/images/orng_1.jpg')
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				this.cancel()
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.placeTitle)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.nametxtField.value)
				this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{예약일시}/g, today)
				// this.messageData1.message = this.messageData1.message.replace(/#{고객정보}/g, url)
			}
			const data = {
				// 필수값

				code: this.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.numSel.value + this.numtxtField.value,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.nametxtField.value,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.eventsData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {
					this.cancel()
				})
				.catch(() => {})
		},
		// 내가받을 알림톡 알림톡
		messages() {
			const data = {
				// tplCode: this.$store.state.reservedayTplCode,
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[1]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
					}
					this.creaetSendMessage()
				})
				.catch(() => {})
		},

		/**** 폭죽놀이
			 @author 전현균
		 */
		firework() {
			const defaults = { startVelocity: 25, spread: 360, ticks: 50, zIndex: 9998 }
			function randomInRange(min, max) {
				return Math.random() * (max - min) + min
			}
			const particleCount = 50 // 줄임
			let count = 0
			let interval = setInterval(() => {
				if (count > 1) {
					// 반복 2회만
					clearInterval(interval)
				}
				count++
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.2, 0.4), y: Math.random() - 0.2 },
					}),
				)
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.6, 0.8), y: Math.random() - 0.2 },
					}),
				)
			}, 400) // 간격도 약간 늘림
		},

		/**** 무기명 참여
 * name : 무기명, phone : 00000000000 으로 데이터 고정
 * 나머지는 로직은 동일
	 @author 전현균
 */
		noPhoneStart() {
			let data2 = {
				name: '무기명',
				phone: '00000000000',
				code: this.code,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store.dispatch('createEventJoin', data2).then(res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal2.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal2.dialog = true
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal2.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal2.dialog = true
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					if (
						res.data.createEventJoin.eventJoin.winnterProduct === '1등 LG TV' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '2등 다이슨 DIGITALSLIM(Y24)' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '3등 필립스 퓨어 프로텍트 프로 공기청정기 3200 시리즈' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '4등 각티슈+송월타올 30수 모나코 130g' ||
						res.data.createEventJoin.eventJoin.winnterProduct === '5등 직사각티슈'
					) {
						this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)
						setTimeout(() => {
							this.spinRoullet()
						}, 500)
						// setTimeout(() => {
						// 	this.lucky = true
						// }, 1000)

						this.check_dialog = false
					} else {
						setTimeout(() => {
							this.print()
						}, 1000)
					}
				}
				this.$store.state.loading = false
			})
		},
	},
}
</script>

<style lang="scss">
@page {
	size: auto; /* auto is the initial value */
	margin: 5mm; /* this affects the margin in the printer settings */
}

#print-background {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print {
	display: none;
}
.check_re_btn {
	width: 200px !important;
	height: 45px !important;
}
.check_complete {
	width: 200px !important;
	height: 45px !important;
}
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
	.infoYear {
		background-color: white;
		color: black;
		font-size: 14px;
		border-radius: 10px 10px 0px 0px;
	}
	.infoHour {
		font-size: 14px;
		font-weight: 100;
	}
}
.v-dialog:not(.v-dialog--fullscreen) {
	max-height: 95% !important;
}
.check_dialog {
	padding: 20px;
	background-color: #ececec;
	.check_layout {
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		.check_sub_layout {
			padding-left: 100px;
		}
		.check_title {
			text-align: center;
			font-size: 47px;
			font-weight: bold;
			color: #631115;
		}
		.check_sub_title {
			font-size: 18px;
			font-weight: bold;
			color: #631115;
		}
		.check_info {
			font-size: 17px;
			padding-left: 35px;
			color: #707070;
		}
	}
}
.radio_label_white {
	label {
		color: white !important;
	}
}
.keypad_btn {
	width: 230px;
	height: 69px !important;
	background-color: white !important;
	font-weight: bold !important;
	border-radius: 15px !important;
	font-size: 26px !important;
}
.keypad_background {
	background-color: rgba(255, 255, 255, 0.43);
	border-radius: 18px;
	padding: 8px;
}

.placeholder-color-white {
	.v-input__control {
		.v-input__slot {
			.v-text-field__slot {
				input {
					font-size: 24px !important;
				}
			}
		}
	}
}
.keypad_agree_content {
	border: 1px solid;
	border-color: rgba(255, 255, 255, 0.5);
	border-radius: 15px;
	white-space: break-spaces;
	color: white;
	font-size: 11px;
	padding: 8px;
	text-align: left;
	height: auto;
	max-height: 276px;
	overflow: auto;
}
.reserve_keypad_maintxt {
	font-size: 24px;
	font-weight: bold;
	color: white;
}
.reserve_keypad_subtxt {
	font-size: 20px;
	color: white;
}
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}

.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}

.roullet_dialog.v-dialog {
	overflow: hidden;
	background: transparent;
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}
</style>
<style lang="scss" scoped>
.start-button-group {
	position: absolute !important;
	bottom: 300px;
	display: flex;
	gap: 30px;
	justify-content: center;
	width: 100%;
}
.start-button {
	background-color: #001a43;
	color: #fff;
	padding: 20px 60px;
	font-size: 64px;
	line-height: 64px;
	font-weight: 700;
	border-radius: 100px;
	cursor: pointer;
	box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-webkit-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-moz-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	border: 4px solid #f4f3f4;
	outline: 3px solid #f4f3f4;
	outline-offset: -1px;
	width: 450px;
}

.nextButton_css {
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 80px !important;
	padding: 0 48px !important;
	height: 100px !important;
	font-size: 60px !important;
	font-weight: bold;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 400px !important;
	justify-content: center;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
	.text {
		margin-right: 18px;
	}
	.arrow {
		font-size: 120px;
		margin-bottom: 28px;
		font-weight: 100;
	}
}
.imageButton {
	height: 100vh;
	.v-responsive__content {
		position: relative;
		.keypad_main_layout {
			padding: 0 28px;
			position: absolute;
			top: 350px;
		}
		.clickBtn {
			position: absolute;
			bottom: 980px;
			width: 100%;
			button {
				height: 120px;
				font-size: 48px;
				font-weight: bold;
				margin: 0 auto;
				min-width: 100px;
				width: 100%;
				max-width: 710px;
				border-radius: 15px;
			}
		}
	}
	text-align: end;
	padding: 20px;
}
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
.roullet_div {
	width: 900px;
	padding-top: 80px;
	position: relative;
}
.roullet_board {
	transform: rotate(15deg);
	width: 100%;
}
.roullet_arrow {
	width: 125px;
	z-index: 1;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0%);
	top: -10px;
}
#print-background-cobe {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
.event-bottom-img {
	position: absolute;
	bottom: 120px;
}
.next-button-container {
	overflow: hidden;
	display: flex;
	justify-content: center;
	margin: 20px;
	margin-bottom: 40px;
}
.reserve-background-width {
	height: 100vh;
	width: 100%;
	min-width: 900px;
	max-width: 1080px;
	margin: 0 auto;
}
/* step1 */
.content_step1 {
	background-color: #001a43;
	color: white;
	padding: 160px 40px 0px 40px;
	text-align: center;
}

.title-small {
	font-size: 36px;
	margin-bottom: 12px;
}

.title-large {
	font-size: 76px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.2;
}

.divider {
	width: 1px;
	height: 60px;
	background-color: #fff;
	margin: 80px auto;
}

.event-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
}
.event-bottom {
	margin: 0 150px;
}
.event-subtitle {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.3;
}

.prizes-container {
	background-color: white;
	border-radius: 30px;
	padding: 40px;
	margin-bottom: 20px;
	display: flex;
	flex-wrap: wrap;
}

.prize-item {
	width: 50%;
	padding: 20px;
	text-align: center;
}

.prize-rank {
	display: block;
	margin-bottom: 20px;
	width: 120px;
	height: 120px;
}

.prize-image {
	width: 160px;
	height: 160px;
	margin: 0 auto 20px;
}

.prize-name {
	color: #001a43;
	font-weight: bold;
	font-size: 32px;
	margin-bottom: 5px;
}

.prize-desc {
	color: #666;
	font-size: 28px;
}

.footnotes {
	text-align: left;
	color: #aaa;
	font-size: 16px;
	line-height: 1.5;
	white-space: pre-line;
}

/* step2 */
.content_step2 {
	background-image: url('~@/assets/images/2_orong.jpg');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	height: 100vh;
	overflow: hidden;
	padding: 20px 40px 0px 40px;
	color: #001a43;
}
.info-section {
	padding: 0px 40px 0px 40px;
}

.info-header {
	color: black;
	letter-spacing: -4px;
	font-size: 48px;
	font-weight: bold;
	margin-top: 130px !important;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 12px;
	text-align: center;
}

.info-form {
	padding: 20px;
	border-radius: 16px;
	background-color: #001a43;
}

.form-group {
	margin-bottom: 20px;
}

.form-label {
	color: white;
	display: block;
	font-size: 32px;
	width: 150px;
	min-width: 150px;
}

.form-input {
	width: 100%;
	height: 80px;
	padding: 10px 20px;
	font-size: 30px;
	border: 1px solid #ccc;
	background-color: white;
	color: black;
}

.info-desc {
	padding: 0px 40px 20px 40px;
	font-size: 28px;
	line-height: 1.6;
	color: #333;
}

/* 동의 섹션 스타일 */
.consent-section {
	margin-bottom: 24px;
}

.consent-header {
	font-size: 22px;
	font-weight: 900;
	color: #5a3e1b;
	margin-bottom: 8px;
	letter-spacing: -1px;
}

.consent-header-icon {
	color: #5a3e1b;
	margin-right: 4px;
}

.consent-description {
	font-size: 14px;
	font-weight: bold;
	color: #222;
	line-height: 1.8;
	margin-bottom: 12px;
	letter-spacing: -0.5px;
}

.consent-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 0;
	border-top: 3px solid #5a3e1b;
	border-bottom: 2px solid #999;
}

.consent-table th,
.consent-table td {
	padding: 12px 16px;
	text-align: left;
	border: 1px solid #bbb;
	font-size: 15px;
	font-weight: bold;
	letter-spacing: -0.5px;
	color: #222;
	white-space: pre-line;
	vertical-align: middle;
}

.consent-table th {
	background-color: #f2f2f2;
	color: #222;
	font-weight: 900;
	width: 32%;
	text-align: center;
	border-right: 1px solid #bbb;
}

.consent-table td {
	background-color: #fff;
}

/* 첫 번째 행 (수집·이용하는 자) - 갈색 헤더 */
.consent-table-header-row th {
	background-color: #7a6140;
	color: #fff;
	font-size: 15px;
	border-color: #7a6140;
}

.consent-table-header-row td {
	background-color: #f0ebe4;
	font-weight: 900;
	color: #222;
	border-color: #bbb;
}

.consent-agree-row {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 0;
	gap: 48px;
}

.consent-agree-label {
	font-size: 17px;
	font-weight: 900;
	color: #5a3e1b;
	letter-spacing: -0.5px;
}

.consent-agree-options {
	display: flex;
	gap: 36px;
}

.consent-option {
	font-size: 17px;
	font-weight: bold;
	color: #333;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 6px;
}

.consent-option.active {
	font-weight: bold;
	color: #5a3e1b;
}

.consent-radio {
	font-size: 16px;
}

.next-button {
	display: block;
	width: 350px;
	height: 80px;
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

/* step3 */
.content_step3 {
	background-image: url('~@/assets/images/3_orong.jpg');
	height: 100vh;
	overflow: hidden;
	padding: 140px 120px 0 120px;
	background-color: #ffffff;
	color: #001a43;
}
.auth-header {
	.bold {
		font-weight: bold;
	}
	background-color: #e9eae4;
	border-radius: 16px;
	padding: 24px 48px 24px 48px;
	width: 100%;
	text-align: center;
	margin-bottom: 50px;
}

.auth-header h1 {
	font-size: 80px;
	font-weight: bold;
	color: #001a43;
	margin-bottom: 25px;
}

.auth-header p {
	font-size: 30px;
	color: black;
	line-height: 1.5;
	margin-bottom: 0px !important;
}

.auth-form {
	background-color: #001a43;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
}

.auth-input-container {
	padding: 0 26px;
	width: 100%;
}

#auth-input {
	width: 100%;
	height: 120px;
	background-color: #dcdedd;
	border: 1px solid #ccc;
	font-size: 50px;
	text-align: center;
	letter-spacing: 10px;
	outline: none;
	cursor: default;
	color: black;
}

.keypad {
	width: 100%;
	background-color: #001a43;
	border-radius: 10px;
	padding: 20px;
}

.keypad-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}

.keypad-row:last-child {
	margin-bottom: 0;
}

.key {
	flex: 1;
	height: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	color: #000;
	border: #000 1px solid;
	font-size: 70px;
	font-weight: bold;
	margin: 0 8px;
	cursor: pointer;
	user-select: none;
	text-align: center;
}

.clear-key {
	font-size: 40px;
	line-height: 1.2;
}

.backspace-key {
	font-size: 55px;
}

.key:active {
	background-color: #999999;
}

.action-button-container {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 70px auto;
}
.action-button-outlined {
	width: 400px;
	height: 100px;
	background-color: white;
	color: #001a43;
	border: border 1px solid #001a43;
	border-radius: 80px;
	font-size: 64px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}
.action-button {
	width: 350px;
	height: 80px;
	background-color: #001a43;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

.action-button:hover {
	background-color: #001a43;
}

/* step4 */
.title-container {
	text-align: center;
}

.main-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
	letter-spacing: -1px;
}

.sub-title {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 100px;
}

.schedule-table {
	width: 100%;
	max-width: 850px;
	margin: 0 auto;
	margin-bottom: 100px;
}

.schedule-table th,
.schedule-table td {
	text-align: center;
	vertical-align: middle;
	height: 140px;
	font-size: 50px;
	font-weight: bold;
}

.schedule-table th {
	background-color: #d5d5d5;
	color: #001a43;
}

.schedule-table td {
	background-color: white;
	color: #001a43;
}

.date {
	font-size: 60px;
}

.day {
	font-size: 40px;
	display: block;
	margin-bottom: 16px;
}

.button-container {
	margin: 100px 0;
}

.reservation-button {
	background-color: white;
	color: #001a43;
	padding: 4px 0;
	width: 400px;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
}
.divider-width {
	margin: 0 auto;
	max-width: 850px;
	width: 100%;
	height: 1px;
	background-color: #fff;
}
.info-block {
	width: 100%;
	max-width: 850px;
	background-color: #d5d5d5;
	color: #001a43;
	padding: 8px 0;
	text-align: center;
	font-size: 48px;
	font-weight: bold;
	margin: 0 auto;
}

.house-info {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	font-size: 57px;
}

.house-separator {
	margin: 0;
}

.contact-number {
	font-size: 120px;
	font-weight: bold;
	margin-bottom: 160px;
}
</style>
